import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CommunicationService } from './communication.service';
import { CommunicationsListComponent } from './list/communications-list.component';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CreateCommunicationComponent } from './create/create-communication.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { InlineEditorModule } from '@qontu/ngx-inline-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { MassCommunicationComponent } from './mass/mass-communication.component';
import { DataTablesModule } from 'angular-datatables';
import { DataTableModule } from 'angular2-datatable';
import { CallerReportComponent } from './reports/caller/caller-report.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SweetAlert2Module,
    NgxSmartModalModule,
    DataTablesModule,
    DataTableModule,
    DropdownsModule,
    BsDatepickerModule,
    NgSelectModule,
    AngularMultiSelectModule,
    AngularDateTimePickerModule,
    InlineEditorModule
  ],
  providers: [
    CommunicationService
  ],
  declarations: [
    CommunicationsListComponent,
    CreateCommunicationComponent,
    MassCommunicationComponent,
    CallerReportComponent
  ],
  exports: [
    CommunicationsListComponent,
    CreateCommunicationComponent,
    MassCommunicationComponent,
    CallerReportComponent
  ]
})
export class CommunicationModule { }



// WEBPACK FOOTER //
// ./client/app/shared/communications/communication.module.ts